export class SavedOffersFilter {
  take: number;
  currentPage: number;

  constructor() {
    this.currentPage = 1;
    this.take = 12;
  }
}
